import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/icon-lock-blue.png'
import _imports_1 from '../../images/wave.png'
import _imports_2 from '../../images/bg-net.png'


const _withScopeId = n => (_pushScopeId("data-v-5740edc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section step-one" }
const _hoisted_2 = { class: "question-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-label" }, " 활동 1 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 바다에 도착했다! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 해안 연안에서 만나지 않은 쓰레기는? ")
], -1))
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "section step-two" }
const _hoisted_9 = {
  key: 0,
  class: "lock-mask"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon-lock"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "question-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-label" }, " 활동 2 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 다음 중 가플지우 캠페인"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 수거 품목이 아닌 것은? ")
], -1))
const _hoisted_15 = { class: "" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "bg-wave"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "bg-net"
}, null, -1))

import { ref } from 'vue';
  import TabTitle from './academy-title.vue';
  import Popup from './academy-popup.vue';
  import { request, kakaoShare, getProgramLink } from '@/utils';
  import { IEmartProgram } from '@/templates/emart/type';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {program: IEmartProgram}

  const answerOne = ref<number>();
  const answerThree = ref<number>();
  const step = ref<number>(1);
  const showShare = ref<boolean>(false);
  const showSuccess = ref<boolean>(false);
  const showError = ref<boolean>(false);
  const stepTwo = ref();

  

  const stepOneQuestion = [
    {
      text: '1. 부표',
      image: require('../../images/question-1.png'),
    },
    {
      text: '2. 비닐봉지',
      image: require('../../images/question-2.png'),
    },
    {
      text: '3. 우주선',
      image: require('../../images/question-3.png'),
    },
  ];

  const stepThreeQuestion = [
    {
      text: ['지구를 사랑하는 마음'],
      image: require('../../images/question-4.png'),
    },
    {
      text: ['쓱싹쓱싹', '(샴푸/세제/분무기통/칫솔)'],
      image: require('../../images/question-5.png'),
    },
    {
      text: ['내가 마신 음료는 내가 직접', '(투명 음료 페트병)'],
      image: require('../../images/question-6.png'),
    },
    {
      text: ['맛있게 먹고 나면 분리배출까지', '올바르게 (즉석밥 용기)'],
      image: require('../../images/question-7.png'),
    },
  ];

  function handleSelectQuestionOne(index: number) {
    if (step.value > 1) {
      return;
    }
    answerOne.value = index;
    if (index === 2) {
      showSuccess.value = true;
      step.value = 2;
      const top = stepTwo.value.offsetTop;
      window.scrollTo(0, top);
    } else {
      showError.value = true;
    }
  }

  function handleSelectQuestionTwo(index: number) {
    if (step.value > 2) {
      return;
    }
    answerThree.value = index;
    if (index === 0) {
      step.value = 3;
      showShare.value = true;
      request.put(`custom_keys/${props.program?.custom_key.id}`, { user_configs: [{ key: 'academy_graduate_count', type: 'cumulative_number', value: 1 }] });
    } else {
      showError.value = true;
    }
  }

  function handleShareKakao() {
    return kakaoShare({
      title: props.program?.share_setting?.share_title || props.program?.name || '',
      imageUrl: props.program?.share_setting?.share_image?.url || props.program?.image?.url,
      link: getProgramLink(props.program as IEmartProgram)
    });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TabTitle, {
      step: "STEP 04.",
      title: "해양 쓰레기, 풀어보기"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stepOneQuestion, (item, index) => {
            return _createElementVNode("div", {
              key: item.text,
              class: _normalizeClass(["item", {active: index === answerOne.value}]),
              onClick: ($event: any) => (handleSelectQuestionOne(index))
            }, [
              _createElementVNode("img", {
                src: item.image,
                class: "image"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", null, _toDisplayString(item.text), 1)
            ], 10, _hoisted_6)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      (step.value < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stepThreeQuestion, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["item", {active: index === answerThree.value}]),
              onClick: ($event: any) => (handleSelectQuestionTwo(index))
            }, [
              _createElementVNode("img", {
                src: item.image,
                class: "image"
              }, null, 8, _hoisted_17),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(index + 1) + ".", 1),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (text) => {
                    return (_openBlock(), _createElementBlock("div", { key: text }, _toDisplayString(text), 1))
                  }), 128))
                ])
              ])
            ], 10, _hoisted_16)
          }), 64))
        ])
      ]),
      _hoisted_19,
      _hoisted_20
    ]),
    _createVNode(Popup, {
      modelValue: showSuccess.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showSuccess).value = $event)),
      text: "정답입니다!",
      "btn-text": "다음",
      icon: require('../../images/cat-success.png'),
      "icon-bg-color": "#006DB7"
    }, null, 8, ["modelValue", "icon"]),
    _createVNode(Popup, {
      modelValue: showError.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showError).value = $event)),
      text: "다시 한번 생각해보세요!",
      "btn-text": "다시 풀기",
      "btn-color": "#C93939",
      icon: require('../../images/cat-fail.png'),
      "icon-bg-color": "#C93939"
    }, null, 8, ["modelValue", "icon"]),
    _createVNode(Popup, {
      modelValue: showShare.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showShare).value = $event)),
      text: "축하해요!<br class='d-md-none'> 가플지우 미래 유물 발굴단이 되셨네요!",
      "btn-text": "카카오톡 친구에게 공유하기",
      "btn-color": "#FDB515",
      icon: require('../../images/cat-success.png'),
      "icon-bg-color": "#006DB7",
      onClickBtn: handleShareKakao
    }, null, 8, ["modelValue", "icon"])
  ], 64))
}
}

})